var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRetryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_337_19451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5713 11.0011C18.5713 13.7584 16.3302 16 13.5735 16C12.0242 16 10.5847 15.3012 9.62932 14.0788C9.50794 13.9239 9.53551 13.6993 9.69071 13.5778C9.8466 13.4543 10.0708 13.4829 10.1923 13.6392C11.011 14.6872 12.2432 15.2878 13.5713 15.2878C15.9351 15.2878 17.857 13.3648 17.857 11.0011C17.857 8.63742 15.9345 6.71445 13.5713 6.71445C12.0333 6.71445 10.636 7.53382 9.86928 8.85778H11.7856C11.982 8.85778 12.1427 9.01853 12.1427 9.215C12.1427 9.41148 11.982 9.57223 11.7856 9.57223H8.92843C8.73111 9.57223 8.57129 9.41148 8.57129 9.215V6.35722C8.57129 6.15986 8.73111 6 8.92843 6C9.12575 6 9.28557 6.15986 9.28557 6.35722V8.44608C10.1874 6.93481 11.799 6.00246 13.5735 6.00246C16.3302 6.00246 18.5713 8.2438 18.5713 11.0011Z",
    fill: "#0F0F0F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.07129,
    y: 0.5,
    width: 25,
    height: 21,
    rx: 3.5,
    stroke: "#0AA1E2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_337_19451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 14,
    fill: "white",
    transform: "translate(8.57129 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetryIcon);
export default __webpack_public_path__ + "static/media/retryIcon.fa11927840e0b451e41894304953743a.svg";
export { ForwardRef as ReactComponent };